// One line for Phoebe’s current step: ticking while working, a still purple
// mark while waiting for input. Finished activity leaves the transcript, so
// this never shows a duration or a list of past steps.
import { type ReactNode } from 'react';

import { type ActivityGroupSummaryViewRow } from '@apps/web/features/phoebe_chat_v3/model/activity';
import { EventLine } from '@apps/web/features/phoebe_chat_v3/ui/primitives/event_line';
import { FlowerMark } from '@apps/web/features/phoebe_chat_v3/ui/primitives/flower_mark';
import { PetalTickLoader } from '@apps/web/features/phoebe_chat_v3/ui/primitives/petal_tick_loader';
import { ResolvedReferenceText } from '@apps/web/features/phoebe_chat_v3/ui/primitives/reference_badge';

export type ActivityGroupProps = Readonly<{
    readonly row: ActivityGroupSummaryViewRow;
    readonly waitingForInput?: boolean;
}>;

export function ActivityGroup({
    row,
    waitingForInput = false,
}: ActivityGroupProps): ReactNode {
    return (
        <EventLine
            className="min-w-0"
            glyph={
                waitingForInput ? (
                    <span
                        role="status"
                        aria-label="Waiting for your input"
                        className="text-agent-action inline-flex size-[1em] dark:text-violet-300"
                    >
                        <FlowerMark className="size-full" />
                    </span>
                ) : (
                    <PetalTickLoader className="size-[1em]" />
                )
            }
        >
            {/* The step line replaces the status strip's live region, so
                step changes are still announced. */}
            <span aria-live="polite">
                <ResolvedReferenceText text={row.summary} />
            </span>
        </EventLine>
    );
}
